export const SET_PROFILE_DETAILS = "SET_PROFILE_DETAILS";
export const SET_COMPANY_DETAILS = "SET_COMPANY_DETAILS";
